import { z } from 'zod';

import { LosId, PayoffId, PropertyId } from '../../BrandedIds';
import { PayoffStatus, TrackedPayoffAllowedPaymentMethods } from '../../loan/Payoffs';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportablePayoff = z
  .object({
    id: zodBrandedUuid<PayoffId>(),
    loanId: zodBrandedString<LosId>(),

    status: PayoffStatus,
    createdAt: zodTemporalInstant,
    expirationDate: zodTemporalPlainDate,
    // wireSettingsId: zodBrandedUuid<CompanyWireSettingsId>().optional(),
    outstandingPrincipal: z.number(),
    outstandingInterest: z.number(),
    outstandingFeeAmount: z.number(),
    outstandingAdvanceAmount: z.number(),
    escrowBalance: z.number(),
    suspenseBalance: z.number(),
    reserveBalance: z.number(),
    totalDue: z.number(),
    isPartial: z.boolean().optional(),
    calculateFromFundingDate: z.boolean().optional(),
    propertyIds: z.array(zodBrandedUuid<PropertyId>()).optional(),
    // reallocateDIFromSuspense: z.boolean().optional(),

    // present when status is processed or reversed
    processedDate: zodTemporalPlainDate.optional(),
    amountPaid: z.number().optional(),
    paymentMethod: TrackedPayoffAllowedPaymentMethods.optional(),
  })
  .meta({ title: 'Payoff' });

export type ExportablePayoff = z.infer<typeof ExportablePayoff>;
